import { SideMenuProps } from './side-menu.types'
import { SideMenu as SideMenuUI } from '@touche-lts/panel-ui/dist'
import { IconArrowLeft, IconArrowRight } from 'assets/icons'
import { User } from 'services'
import { navMenu } from './side-menu.menu'
import { observer } from 'mobx-react-lite'
import styles from './side-menu.module.scss'
import cl from 'classnames'
import { useRootStore } from 'mobx-stores/store-provider'

const SideMenuComponent = (props: SideMenuProps) => {
  const { className, style } = props
  const {
    routingStore: {
      push,
      location: { pathname }
    }
  } = useRootStore()

  const visibleMenu = navMenu.filter(item =>
    !item.allowedRoles || item.allowedRoles.some(role => User.userRoleNames.includes(role))
  )

  return (
    <SideMenuUI
      className={cl(styles.sideMenu, className)}
      style={{ backgroundColor: styles.primaryContent, ...style, padding: '40px 0 40px 10px', position:'absolute' }}
      iconArrowLeft={IconArrowLeft}
      iconArrowRight={IconArrowRight}
      isUserAuthenticated={User.isAuthenticated}
      navMenu={visibleMenu.map(navProps => {
        const isSelected = pathname.includes(navProps.navPath)
        return {
          icon: navProps.icon,
          label: navProps.label,
          onClick: () => push(navProps.navPath),
          isSelected,
          notAllowedForLoggedUser: false,
          disabled: !User.isAuthenticated,
          className: cl(styles.button, {
            [styles.buttonSelected]: isSelected
          })
        }
      })}
    />
  )
}

const SideMenu = observer(SideMenuComponent)
export { SideMenu }
